import { createClient } from "@connectrpc/connect";
import { CorrelationService } from "@reliquo/proto/correlation/connect";
import { createTransport } from "./transport";

export function getCorrelationClient(accessToken: string | null) {
  return createClient(CorrelationService, createTransport(accessToken));
}
